export function buildListingPhotoAlt(
  displayName: string | undefined,
  caption: string | undefined,
  index: number,
): string {
  if (caption) return caption;
  if (displayName) return `${displayName} — Photo ${index + 1}`;
  return `Property photo ${index + 1}`;
}
